export default {
      id: "file-usage",
      viewBox: "0 0 8.467 8.467",
      url: __webpack_public_path__ + "img/icons.svg#file",
      toString: function () {
        return this.url;
      }
    }